// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__JBWaF","list":"styles_list__pZK6P"};